"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXERCISE_DURATION_STEP_VALUE = exports.EXERCISE_DURATION_MAX_VALUE = exports.EXERCISE_DURATION_MIN_VALUE = exports.EXERCISE_DESCRIPTION_MAX_LENGTH = exports.EXERCISE_ACTIVITY_TYPES = void 0;
var EXERCISE_ACTIVITY_TYPES = {
  BABYEXERCISE: 'BABYEXERCISE',
  BALL_GAMES: 'BALL_GAMES',
  CARDIO: 'CARDIO',
  CYCLING: 'CYCLING',
  DANCING: 'DANCING',
  GARDENING: 'GARDENING',
  GOLF: 'GOLF',
  HORSERIDING: 'HORSERIDING',
  HOUSEWORK: 'HOUSEWORK',
  INTERWALK: 'INTERWALK',
  OTHER: 'OTHER',
  PILATES: 'PILATES',
  PROGRAM: 'PROGRAM',
  RACQUET: 'RACQUET',
  REHABILITATION: 'REHABILITATION',
  RUNNING: 'RUNNING',
  SWIMMING: 'SWIMMING',
  WALKING: 'WALKING',
  WEIGHTS: 'WEIGHTS',
  YOGA: 'YOGA'
};
exports.EXERCISE_ACTIVITY_TYPES = EXERCISE_ACTIVITY_TYPES;
var EXERCISE_DESCRIPTION_MAX_LENGTH = 256;
exports.EXERCISE_DESCRIPTION_MAX_LENGTH = EXERCISE_DESCRIPTION_MAX_LENGTH;
var EXERCISE_DURATION_MIN_VALUE = 5;
exports.EXERCISE_DURATION_MIN_VALUE = EXERCISE_DURATION_MIN_VALUE;
var EXERCISE_DURATION_MAX_VALUE = 495;
exports.EXERCISE_DURATION_MAX_VALUE = EXERCISE_DURATION_MAX_VALUE;
var EXERCISE_DURATION_STEP_VALUE = 5;
exports.EXERCISE_DURATION_STEP_VALUE = EXERCISE_DURATION_STEP_VALUE;